<script>
  import Shafts from './Shafts.svelte'
  import { getName, LogOut, checkCookie, setCookie, getCookie } from '../utils/utils.js';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  var shafts = [
    { x: '', xt:'', y: '', yt:'', v: '', vt: '' },
    { x: '', xt:'', y: '', yt:'', v: '', vt: '' }
  ];
  var axles = [
    { x: '', xt:'', y: '', yt:'', v: '', vt: '' }
  ];
  let object;
  async function createReducer(shafts, axles) {
    fetch(
      "/api/reducer/create", 
      {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'same-origin', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Authorization': `Bearer ${getCookie("access.6bgdz9n7")}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(
          {
              "shafts": shafts, 
              "axles": axles
          }
        ) // body data type must match "Content-Type" header
      }
    )
    .then(res => dispatch('create-event'))
    .then(resetSA)    
  }
  function resetSA() {
    shafts = [
      { x: '', xt:'', y: '', yt:'', v: '', vt: '' },
      { x: '', xt:'', y: '', yt:'', v: '', vt: '' }
    ];
    axles = [
      { x: '', xt:'', y: '', yt:'', v: '', vt: '' }
    ];
    return {shafts,axles}
  }
    



function sayHello() {
  
}
    
  </script>
  
  <div class="form">
    <form method="POST" action="/api/reducer/create" on:submit|preventDefault={createReducer(shafts, axles)}>
      
      <div class="section">
        <Shafts max_items={7} bind:shafts={shafts} text="Output shafts position, speed and tolerances"/>
      </div>

      <div class="section">
        <Shafts max_items={1} bind:shafts={axles} text="Driving axle position, speed and tolerances"/>
      </div>

      <div class="section" style="border:none"><input type="submit" value="Create this reducer!"></div>
      
    </form>
</div>
  
<style>
  

input[type=submit] {
    width: 100%;
    color: white;
    padding: 14px 20px;
    margin: 1px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: #6baed6;
    font-size: 20px;
}
      
.section {
    display: block;
    border: 2px solid #6baed6;
    padding: 0px;
    margin: 7px;
}
  
  
  
    
.form { 
    /*min-width: 300 px;*/
    background-color: rgb(255, 230, 255);
    padding: 0px;
    margin: 0px;
}

    
  
    
</style>